/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { Service } from 'services';

class PropertiesPanelFeelPlaygroundService extends Service {
  /**
   * Used for evaluating of a FEEL expression (with a given context/input variables)
   * @param {Object} payload
   * @returns {Promise} - the promise of evaluation result
   */
  evaluateFeelExpression(payload, signal) {
    return this.post(`/internal-api/feel/evaluate`, payload, null, null, signal);
  }
}

export const propertiesPanelFeelPlaygroundService = new PropertiesPanelFeelPlaygroundService();
